import type { IconSvgObject } from './types';

const ArrowUpFromLineIcon: IconSvgObject = [
  ["path", { d: "M4 6L7 3L10 6M7 3.5V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 6L17 3L20 6M17 3.5V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 21H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowUpFromLineIcon;
